import {
  titleUI,
  descriptionUI,
  radioUI,
  radioSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import HealthEnrollmentDescription from '../../../components/FormDescriptions/HealthEnrollmentDescription';
import RegistrationOnlyNote from '../../../components/FormDescriptions/RegistrationOnlyNote';
import { emptyObjectSchema } from '../../../definitions';
import content from '../../../locales/en/content.json';

const TITLE_TEXT = content['benefits--reg-only-title'];
const DESC_TEXT = content['benefits--reg-only-description'];
const INPUT_LABEL = content['benefits--reg-only-label'];

const SCHEMA_LABELS = {
  fullPackage: content['benefits--reg-only-full-package-label'],
  regOnly: content['benefits--reg-only-service-connected-label'],
};
const SCHEMA_ENUM = Object.keys(SCHEMA_LABELS);

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    ...descriptionUI(HealthEnrollmentDescription),
    'view:vaBenefitsPackage': radioUI({
      title: INPUT_LABEL,
      labels: SCHEMA_LABELS,
    }),
    'view:addtlInfo': descriptionUI(RegistrationOnlyNote),
  },
  schema: {
    type: 'object',
    required: ['view:vaBenefitsPackage'],
    properties: {
      'view:vaBenefitsPackage': radioSchema(SCHEMA_ENUM),
      'view:addtlInfo': emptyObjectSchema,
    },
  },
};
